// The booking pages' timezones, in one place: the viewer's own, a stored
// zone made safe for Intl (a bad one throws), and the first usable one of
// several. Pure.

export const DEFAULT_TIMEZONE = "Europe/London";

/** Whether Intl knows the zone. */
function isKnown(zone: string): boolean {
  try {
    new Intl.DateTimeFormat("en-GB", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
}

/** The viewer's own timezone. */
export function viewerTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

/** A zone Intl accepts, else London. */
export function safeTimezone(timezone: string | undefined | null): string {
  return timezone && isKnown(timezone) ? timezone : DEFAULT_TIMEZONE;
}

/** The first zone Intl knows, or nothing (what a booking is stamped with:
 * the listing's zone, never the viewer's). */
export function knownTimezone(...candidates: Array<string | undefined | null>): string | undefined {
  return candidates.find((zone): zone is string => !!zone && isKnown(zone));
}

/** The first usable zone of those given (the listing's, the school's), else
 * the viewer's (v1's resolveDisplayTimezone): the clock a date is shown on. */
export function displayTimezone(...candidates: Array<string | undefined | null>): string {
  return knownTimezone(...candidates) ?? viewerTimezone();
}
